import { render, staticRenderFns } from "./alertas.vue?vue&type=template&id=fc6807f0&scoped=true&"
import script from "./alertas.vue?vue&type=script&lang=js&"
export * from "./alertas.vue?vue&type=script&lang=js&"
import style0 from "./alertas.vue?vue&type=style&index=0&id=fc6807f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6807f0",
  null
  
)

export default component.exports